import { makeEditorModal } from '../Modal';
import { Editor } from 'tinymce';
import { editing, getData, insertToEditor, selectNode, setWindowNode, toJsonHtml } from '../core/Utils';
import { insertData } from '../save/SaveTask';
import { data } from 'jquery';
import { FeatureClass } from '../core/FeatureClass';

interface PopupData {
    text: string | '';
    seconds: number | 1;
    type?: string | 'popup';
}

export function addPopup(editor:Editor){
    const config = {
        featureName: "popup",
        editor: editor,
        id: "popup",
        icon: "browse",
        tooltip: 'Popup erstellen',
        menuItems: [{
            name: 'edit-popup',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                createPopupModal(editor, command, data);
            }
        },{
            name: 'show-popup',
            icon: 'image',
            text: 'Anzeigen',
            action: () => {
                const node = editor.selection.getNode();
                const data = getData(node);
                showPopup(data);
            }
        }],
        buttonAction: (command:string) => {
            createPopupModal(editor, command, {text: '', seconds: 1});
        },
        commandAction: (data:PopupData) => {
            insertPopup(data, editor);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}


const createPopupModal = (editor:Editor, command:string,  data:PopupData): void => {
    const content = '<div class="convert-to-popup">' +
    '<p>Hier kannst du ein Popup erstellen, dass in der Übung kurz angezeigt wird.</p>' +
    '<textarea id="popup-text" class="form-control" style="height: 200px;" placeholder="Der Text hieraus wird kann als Popup angezeigt werden...">'+data.text+'</textarea>' +
    '</div>';
    const settings = {
        submitBtn: {
            text: 'Einfügen',
            class: 'add-popup',
        },
        leftInput: {
            placeholder: 'Dauer',
            text: 'in Sekunde(n)',
            type: "number",
            value: data.seconds,
        }
    }

    const modalId = "create-popup";
    const onclick = function(modal){

        const data = getDataFromModal(modal);
        if (data){
            editor.execCommand(command, data)
            return true;
        }
    }
    const modal = makeEditorModal(modalId, 'Popup Erstellen', content, settings, onclick);
    $("#popup-text").focus();
}

function getDataFromModal(modal){
    const text = modal.find("#popup-text").val();
    const seconds = modal.find(".left-input").val();
    return {
        text: text,
        seconds: seconds,
    }
}


function insertPopup(data:PopupData, editor: Editor){
    const html = transformPopupForInsert(data);
    insertToEditor(html);
}

export function transformPopupForInsert(data:PopupData){
    data.type = "popup";
    const json = toJsonHtml(data);
    const html = '<button id="popup" data-json="' + json + '" class="mceNonEditable prop-item btn btn-light-info text-info">Popup Öffnen</button>'
    return html;
}

export function transformPopup(data){
    const html = '<button class="btn btn-light-info text-info show-popup" data-text="' + data.text + '" data-sek="' + data.seconds + '"><i class="fa fa-eye text-info"></i></span>';
    return html;
}


function showPopup(data:PopupData){
    const html = `<div id="popup-modal" class="p-modal-container k-modal">
        <div class="p-modal-bg p-no-bg"></div>
        <div class="p-modal">
            <div class="p-inmodal p-modal-editor" style="max-width: 550px; max-height: 300px; height: auto;">
                <div class="p-upload p-m-topic">
                    <div class="show-text">${data.text}</div>
                    <p class="h-m-p"></p>
                </div>
            </div>
        </div>
    </div>`;
    $(document.body).append(html);
    const modal = $("#popup-modal");
    $(".k-modal .p-inmodal").css("text-align", "center").css("font-size", "4vw");
    modal.show();
    setTimeout(() => {
        modal.hide();
        modal.remove();
    }, 1000 * data.seconds)
}
